import { isNullOrEmpty } from "./isNullOrEmpty";
import { getFetch } from "./getFetch";
import TomSelect from "tom-select";
import i18next from "i18next";
import { inicializarInternacionalizacao } from "../localizacao/selectCidades/selectCidades";


export async function selectCidades(url, id, $element, selectedValue) {
    inicializarInternacionalizacao()
    if (isNullOrEmpty(id) || id == '0') {
        $element.innerHTML = '<option value=""></option>';
        return;
    }
    $element.innerHTML = `<option value="">${i18next.t('SelectCidadeGenericoCarregando')}</option>`;

    const callbackSucesso = function (resultado) {
        let html = [];
        html.push(`<option value="">${i18next.t('SelectCidadeGenericoPlaceholder')}</option>`);

        for (let i = 0; i < resultado.dados.length; i++) {
            html.push('<option value="' + resultado.dados[i].id + '"' + ((selectedValue == resultado.dados[i].id || selectedValue == resultado.dados[i].sigla) ? ' selected ' : '') + '>' + resultado.dados[i].nome + '</option>');
        }
        $element.innerHTML = html.join('');

        if (url == 'estados') {
            if (!isNullOrEmpty(selectedValue)) {
                $element.dispatchEvent(new Event('change'));
            }
            document.getElementById('cidadeID').innerHTML = `<option value="">${i18next.t('SelectCidadeGenericoEstadoObrigatorio')}</option>`;
        }
    };
    const callbackErro = function (resultado) {
    };

    await getFetch(`${URL_API}variaveis/${url}/${id}`, callbackSucesso, callbackErro);
}


export async function selectCidadesTomSelect(url, estadoInput, elementId) {
    if(!estadoInput)
        return;

    inicializarInternacionalizacao();

    const tomSelectCidade = new TomSelect(elementId, {
        placeholder: i18next.t('SelectCidadeGenericoEstadoObrigatorio'),
        valueField: 'id',
        labelField: 'nome',
        searchField: 'nome',
        maxOptions: 20,
        persist: false,        
        preload: true,      
        loadThrottle: 300, 
        onInitialize: function () {
            this.setValue('');
        },
        render: {
            no_results: function(data, escape) {
                return '<div class="no-results">'+ i18next.t('SelectCidadeNenhumResultadoEncontrado') +'</div>';
            }
        },
        load: async function(query, callback) {
            
            if(estadoInput.value == null || isNullOrEmpty(estadoInput.value)){
                callback();
                return;
            }

            const callbackSucesso = (json) => {
                callback(json.dados || []); 
            }
            const callbackErro = () => {
                callback();
            }
            
            await getFetch(`${URL_API}variaveis/${url}/${estadoInput.value}`, callbackSucesso, callbackErro);

            if(url == "cidades"){
                document.dispatchEvent(new CustomEvent('OpcoesCidadesCarregadasEvent'));
            }
        },
        onFocus: function() {
            this.load('', () => {
                this.refreshOptions(false);
            });
        }
    });

    estadoInput.addEventListener("change", function (e) {
        const id = e.target.value;

        tomSelectCidade.setValue('');
        tomSelectCidade.clearOptions();
        
        if (id != null && !isNullOrEmpty(id)) {
            tomSelectCidade.settings.placeholder = i18next.t('SelectCidadeGenericoPlaceholder');
            tomSelectCidade.inputState(); // Atualiza o estado do input para refletir o novo placeholder
            return;
        }
        else{
            tomSelectCidade.settings.placeholder = i18next.t('SelectCidadeGenericoEstadoObrigatorio');
            tomSelectCidade.inputState(); // Atualiza o estado do input para refletir o novo placeholder
            return;
        }
    });

    return tomSelectCidade;
}
